'use client'

import type { BreakpointToken } from '@/styled-system/tokens'
import { token } from '@/styled-system/tokens'
import { useMedia } from 'react-use'

export default function useBreakpoint(breakpoint: BreakpointToken) {
  const match = useMedia(
    `(min-width: ${token(`breakpoints.${breakpoint}`)})`,
    false
  )

  return match
}
